import axios from 'axios';

const axiosPublic = axios.create(); // nessun token

export default axiosPublic;
